import React, {useState, useEffect} from 'react';
import {
  TouchableOpacity,
  Text,
  StyleSheet,
  Image,
  View,
  Dimensions,
} from 'react-native';
// import downArrow from '../assets/down.png';
// import upArrow from '../assets/up-arrow.png';
// import {font1} from '../constants/fonts';
import {AiOutlineDown, AiOutlineUp} from 'react-icons/ai';

const windowWidth = Dimensions.get('window').width;
const isWeb = windowWidth > 600;

const Accordion = (props) => {
  const [accordion, setAccordion] = useState(false);

  useEffect(() => {
    setAccordion(props.active);
    // return () => {
    //   cleanup
    // }
  }, [props.active]);

  return (
    <>
      <View style={styles.container}>
        <TouchableOpacity
          style={styles.accordion}
          onPress={() => {
            // if (props.active) {
            setAccordion(!accordion);
            // }
            // props.onClick(props.id);
          }}>
          <Text style={styles.accordionName}>{props.name}</Text>
          {accordion ? (
            <AiOutlineUp color="white" />
          ) : (
            <AiOutlineDown color="white" />
          )}
        </TouchableOpacity>
        {accordion && props.children}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 30,
  },
  accordion: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#ccccccb0',
    paddingHorizontal: 26,
    paddingBottom: 16,
  },
  accordionName: {
    color: '#cdcddaf5',
    fontWeight: 'bold',
    fontSize: isWeb ? 14 : 12,
    letterSpacing: 1,
    // fontFamily: font1,
  },
  icon: {
    width: isWeb ? 17 : 15,
    height: isWeb ? 17 : 15,
  },
});

export default Accordion;
